import Vue from 'vue'

/**
 * Pluralize a word based off number
 */
Vue.filter('pluralize', function (word, amount) {
  if (amount === 0 || amount > 1) {
    return `${word}s`
  } else {
    return word
  }
})
